import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import {
  CommunityConnectorMode,
  clearLoginRequestFromStorage,
  clearMemberDetailsFromStorage,
  clearModeFromStorage,
  clearSessionFromStorage,
  saveModeToStorage,
  saveSessionToStorage,
  clearBulkReferral,
  clearDeclinedScreener,
  clearIdentifiedNeeds,
  clearsaveFromSearch,
  clearCheckDisableScreening,
  clearVendor
} from '@src/utills/storage';

export const Load = () => {
  const { getRouteParams } = useRouter();
  const { navigate } = useRouter();
  const [isLoading, setIsLoading] = React.useState(true);

  const params = getRouteParams();

  const { mode } = params;
  const sessionId: string = params.session;

  useEffect(() => {
    clearSessionFromStorage();
    clearLoginRequestFromStorage();
    clearModeFromStorage();
    clearMemberDetailsFromStorage();
    clearBulkReferral();
    clearDeclinedScreener();
    clearIdentifiedNeeds();
    clearsaveFromSearch();
    clearCheckDisableScreening();
    clearVendor();
    saveSessionToStorage(sessionId);
    saveModeToStorage(mode);
    navigate('/redirect');
  }, []);
  return (
    <React.Fragment>
      {isLoading ? (
        <div
          style={{
            zIndex: 999,
            backgroundColor: '#FFFFFF',
            opacity: 0.75,
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LoadingSpinner
            size="xl"
            isLoading={isLoading}
            ariaLoadingLabel="Downloading files"
          />
        </div>
      ) : (
        ``
      )}
    </React.Fragment>
  );
};
